type Props = {
  vendor: string;
  size: 'small' | 'medium' | 'large';
  customSrc?: string;
};

export const VendorLogoBlock = ({ vendor, size, customSrc }: Props) => {
  return (
    <div
      className={`flex items-center justify-center rounded bg-white ${size === 'small' ? 'h-7 w-7' : size === 'medium' ? 'h-8 w-8' : 'h-10 w-10'}`}
    >
      <img
        src={customSrc || `${process.env.REACT_APP_IMG_URL}/images/favis/32/${vendor}.png`}
        alt='vendor-logo'
        loading='lazy'
        className={`rounded-sm ${size === 'small' ? 'h-6 w-6' : size === 'medium' ? 'h-7 w-7' : 'h-9 w-9'}`}
      />
    </div>
  );
};
